<div class="row JobFilter-Header">
    <div class=" col-md-12 Mobile-P-0 Mobile-P-15 p-0">
        <h2 *ngIf="ContextService.IsJobSeeker" class="float-left d-inline-block" (click)="OnSearchFilterToggle()">{{ContextService.IsJobSeeker ? 'Job':'CV'}} Search Filters</h2>
        <div class="float-right ExpandFilter" (click)="OnSearchFilterToggle()">{{ SearchService.IsFilterExpandedMobile ? 'Collapse' : 'Expand'}}
            <i *ngIf="!SearchService.IsFilterExpandedMobile" class="fas fa-angle-down ml-2"></i>
            <i *ngIf="SearchService.IsFilterExpandedMobile" class="fas fa-angle-up ml-2"></i>
        </div>
    </div>
    <div class="col-md-12 Mobile-P-0 Mobile-P-15 p-0 accordion slide" [ngClass]="SearchService.IsFilterExpandedMobile ? 'ShowSlideDown' : 'HideSlideDown'" id="JobFilters">
        <div class="card" *ngIf="(IsSearchFilterInitialized || ContextService.IsDesktopView)">
            <div class="card-header" data-toggle="collapse" href="#Radius" >
                <span class="title">Distance</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="Radius" class="collapse show in">
                <div class="card-body">
                    <div class="form-group mb-0" (click)="OnFocusRadiusDropdownBox()">
                        <select id="radius" name="radius" on-change="OnRadiusChange()" class="form-control form-control-sm" [disabled]="SearchService?.IsRadiusDisabled" 
                        [(ngModel)]="SearchService.SearchParams.Radius" title="{{SearchService?.IsRadiusDisabled ? 'For Distance, please add location' : 'Select miles to search within'}}" 
                        aria-label="Distance">
                            <option [value]="0">{{SearchService?.IsRadiusDisabled ? 'For Distance, please add location' : 'Within?'}}</option>
                            <option [value]="1">1 Mile</option>
                            <option [value]="2">2 Miles</option>
                            <option [value]="5">5 Miles</option>
                            <option [value]="10">10 Miles</option>
                            <option [value]="15">15 Miles</option>
                            <option [value]="20">20 Miles</option>
                            <option [value]="25">25 Miles</option>
                            <option [value]="30">30 Miles</option>
                            <option [value]="40">40 Miles</option>
                            <option [value]="50">50 Miles</option>
                            <option [value]="60">60 Miles</option>
                            <option [value]="70">70 Miles</option>
                            <option [value]="100">100 Miles</option>
                            <option [value]="1000">Any</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" data-toggle="collapse" href="#SearchWithin">
                <span class="title">Search within last</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="SearchWithin" class="collapse show in">
                <div class="card-body">
                    <div class="form-group mb-0" *ngIf="ContextService.IsRecruiter">
                        <select class="form-control form-control-sm" [(ngModel)]="SearchService?.SearchParams.SearchWithIn"
                            (change)="OnSearchWithinChange()" aria-label="Search within last">
                            <option *ngFor="let search of SearchWithInFilterCollection" [value]="search.Id">{{ search.Description }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group mb-0" *ngIf="ContextService.IsJobSeeker">
                        <select class="form-control form-control-sm" [(ngModel)]="SearchService?.SearchParams.SearchWithIn"
                            (change)="OnSearchWithinChange()" aria-label="Search within last">
                            <option *ngFor="let search of JobSearchWithInFilterCollection" [value]="search.Id">{{ search.Description }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" *ngIf="ContextService.IsJobSeeker">
            <div class="card-header" data-toggle="collapse" href="#JobType">
                <span class="title">Employment Type</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="JobType" class="collapse show in">
                <div class="card-body">
                    <div class="custom-control form-control-md custom-checkbox" *ngFor="let jobType of JobTypes">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="jobType.isChecked"
                            on-change="OnJobTypeChange(jobType.Id)" id="chkJobType_{{jobType.Id}}" />
                        <label class="custom-control-label"
                            for="chkJobType_{{jobType.Id}}">{{jobType.Description}}</label>
                    </div>
                </div>
            </div>
        </div>
    
         <div class="card" *ngIf="ContextService.IsRecruiter">
            <div class="card-header" data-toggle="collapse" href="#positionType">
                <span class="title">Employment Type</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="positionType" class="collapse show in">
                <div class="card-body">
                    <div class="custom-control form-control-md custom-checkbox" *ngFor="let positionType of PositionTypes">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="positionType.IsChecked"
                            on-change="OnPositionTypeChange(positionType.Id)"
                            id="chkPositionType_{{positionType.Id}}" />
                        <label class="custom-control-label"
                            for="chkPositionType_{{positionType.Id}}">{{positionType.Description}}</label>
                    </div>
                </div>
            </div>
        </div>
         <div class="card" *ngIf="ContextService.IsRecruiter">
            <div class="card-header" data-toggle="collapse" href="#candidateType">
                <span class="title">CV Profile</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="candidateType" class="collapse show in">
                <div class="card-body">
                    <div class="custom-control form-control-md custom-checkbox" *ngFor="let candidateType of CandidateTypes">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="candidateType.IsChecked"
                            on-change="OnProfileTypeChange(candidateType.Id)" id="chkCandidateType_{{candidateType.Id}}" />
                        <label class="custom-control-label"
                            for="chkCandidateType_{{candidateType.Id}}">{{candidateType.Description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" data-toggle="collapse" href="#Industries" (click)="LoadSectors()">
                <span class="title">Industries</span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="Industries" class="collapse show">
                <div class="card-body">
                    <div class="form-group sector-height">
                        <div class="custom-control form-control-md custom-checkbox" *ngFor="let sector of Sectors;">
                            <input type="checkbox" class="custom-control-input" [(ngModel)]="sector.IsChecked"
                                (change)="OnSectorSelectionChange()" id="chkSector_{{sector.Id}}"/>
                            <label class="custom-control-label" for="chkSector_{{sector.Id}}">{{sector.SectorName}} {{ContextService.IsJobSeeker ? 'Jobs':'CVs'}}</label>
                        </div>                       
                    </div>                    
                </div>
            </div>
        <div class="card salary-card">
            <div class="card-header" [ngClass]="SearchService.SearchParams.IsSalaryRangeFilterApplied ? '' : 'collapsed'" data-toggle="collapse" href="#Salary">
                <span class="title">Salary </span>
                <span class="accicon"><i class="fas fa-angle-down rotate-icon"></i></span>
            </div>
            <div id="Salary" class="collapse" [ngClass]="SearchService.SearchParams.IsSalaryRangeFilterApplied ? 'show' : ''">
                <div class="card-body">
                    <div class="form-group custom-control form-control-md custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="SearchService?.SearchParams.IncludeUnspecifiedSalaries"
                            (change)="OnIncludeUnspecifiedSalariesChange()" id="chkIncludeUnspecifiedSalaries" />
                        <label class="custom-control-label"
                            for="chkIncludeUnspecifiedSalaries">Include unspecified salaries</label>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control form-control-sm" placeholder="£ Min"                        
                        (keydown)="restrictInput($event)"
                        (input)="validateDecimal($event, 'SalaryFrom')" 
                          (input)="OnSalaryChange()"
                          [(ngModel)]="SearchService?.SearchParams.SalaryFrom" 
                          maxlength="10" />
                      </div>
                    <div class="form-group" [formGroup]="SalaryValidationForm" novalidate>
                        <input type="text" class="form-control form-control-sm"placeholder="£ Max" 
                          (keydown)="restrictInput($event)"
                          (input)="validateDecimal($event, 'SalaryTo')"
                          (input)="OnSalaryChange()" 
                          [(ngModel)]="SearchService.SearchParams.SalaryTo" maxlength="10" [ngModelOptions]="{standalone: true}" />
                        <input type="date" class="d-none" formControlName="MaxGreaterThanMin" />
                        <div *ngIf="SalaryValidationForm.controls['MaxGreaterThanMin'].invalid && SalaryValidationForm.controls['MaxGreaterThanMin'].errors['required']" 
                          class="alert alert-danger mt-2">
                          <i class="fas fa-info-circle"></i> Max salary should be greater than min salary.
                        </div>
                      </div>
                    <div class="form-group mb-0">
                        <select class="form-control form-control-sm" name="salaryDuration"
                            [(ngModel)]="SearchService?.SearchParams.SalaryDuration" (change)="OnSalaryPerChange()">
                            <option value="0">Salary Per</option>
                            <option *ngFor="let duration of SalaryDurations" [value]="duration.Id">
                                {{duration.Description}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="card">
            <div class="card-body text-right">               
                <button type="button" class="btn btn-success btn-sm btn-block applyBtn" (click)="ApplyFilterHandler()">Apply Filters</button>
                <button type="button" class="btn btn-light btn-sm btn-block" (click)="OnResetSideBarFilters()">Clear</button>
            </div>
        </div>
    </div>
</div>
